import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Flame } from "lucide-react";

export default function StreakBadge() {
  const { data } = useQuery({
    queryKey: ["recap-streak"],
    queryFn: async () => (await api.get("/recap/streak")).data,
  });

  if (!data) return null;
  const { streak, total_recaps } = data;
  const active = streak > 0;

  return (
    <div
      className="inline-flex items-center gap-2 px-3 py-1.5"
      style={{
        borderRadius: "10px",
        border: `1px solid ${active ? "rgba(168,85,247,0.35)" : "var(--border)"}`,
        background: active ? "var(--accent-soft)" : "var(--surface)",
      }}
      data-testid="streak-badge"
    >
      <Flame className="h-3.5 w-3.5" strokeWidth={1.5} style={{ color: active ? "var(--accent)" : "var(--fg-3)" }} />
      <span className="text-[10px] tracking-widest" style={{ color: "var(--fg-3)" }}>RECAP STREAK</span>
      <span className="text-sm font-medium" style={{ color: active ? "var(--accent)" : "var(--fg-2)", fontVariantNumeric: "tabular-nums" }}>
        {streak}{streak === 1 ? " day" : " days"}
      </span>
      {total_recaps > 0 && <span className="text-xs" style={{ color: "var(--fg-3)", fontVariantNumeric: "tabular-nums" }}>· {total_recaps} total</span>}
    </div>
  );
}
